import React from "react";
import { marked } from "marked";

import './parseMessage.css';

export const ParseMessage = ({ message, className }) => {
  // Parse markdown to HTML using marked
  const createMarkup = (text) => {
    return { __html: marked.parse(text || "") };
  };

  return (
    <div
      className={`parseMessage ${className || ''}`}
      dangerouslySetInnerHTML={createMarkup(message)}
    />
  );
};
